// removed by extract-text-webpack-plugin
module.exports = {"base":"_1y0qb3l5yZ3JzFpUAML-5K"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StatusPictogram.scss
// module id = 1234
// module chunks = 0